import { render, staticRenderFns } from "./SlipsMDA.vue?vue&type=template&id=6347a9fe&scoped=true&"
import script from "./SlipsMDA.vue?vue&type=script&lang=js&"
export * from "./SlipsMDA.vue?vue&type=script&lang=js&"
import style0 from "./SlipsMDA.vue?vue&type=style&index=0&id=6347a9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347a9fe",
  null
  
)

export default component.exports